export default __webpack_public_path__ + "static/media/c.a53dc2c4.png";